import { useState } from "react";
import { useLang } from "../../i18n/LanguageContext";

export default function Contact() {
  const { t } = useLang();
  const [submitted, setSubmitted] = useState(false);

  function handleSubmit(e) {
    e.preventDefault();
    setSubmitted(true);
    setTimeout(() => setSubmitted(false), 5000);
  }

  return (
    <section id="contact" className="py-32 bg-[#111112] relative">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center space-y-3 mb-16">
          <div className="text-[#F28C18] uppercase text-xs font-black tracking-widest">{t.contact.label}</div>
          <h2 className="text-3xl sm:text-5xl font-black tracking-tight text-white uppercase">{t.contact.title}</h2>
          <div className="w-20 h-1 bg-[#F28C18] mx-auto rounded" />
        </div>

        <div className="grid lg:grid-cols-12 gap-16">
          {/* Left info */}
          <div className="lg:col-span-5 space-y-8">
            <p className="text-zinc-500 text-sm leading-relaxed font-light">{t.contact.sub}</p>
            <div className="space-y-3">
              {[
                { label:t.contact.hq,  address:"Abdel Rahman El Rafie St, Building 70, Apt 1", city:"Cairo, Egypt." },
                { label:t.contact.ops, address:"El Obour City, Entertainment District", city:"Building 46, Apt 1, Egypt." },
              ].map(o => (
                <div key={o.label} className="p-5 rounded-xl bg-[#1A1A1C] border border-white/5 space-y-1">
                  <span className="text-[#F28C18] font-black uppercase text-[10px] tracking-wider block">{o.label}</span>
                  <span className="text-white font-bold block text-sm">{o.address}</span>
                  <span className="text-zinc-500 block text-xs">{o.city}</span>
                </div>
              ))}
            </div>
            <div className="grid sm:grid-cols-2 gap-3 text-xs">
              {[
                { href:"tel:01112073337",  label:t.contact.desk1,  num:"01112073337",   icon:"fa-phone" },
                { href:"tel:01019966583",  label:t.contact.desk2,  num:"01019966583",   icon:"fa-phone" },
              ].map(c => (
                <a key={c.href} href={c.href}
                  className="p-4 bg-white/5 rounded-xl border border-white/5 hover:border-[#F28C18]/40 flex items-center gap-3 transition-all">
                  <i className={`fas ${c.icon} text-[#F28C18] text-base`} />
                  <div>
                    <span className="text-[9px] block uppercase text-zinc-500 font-bold">{c.label}</span>
                    <span className="font-black text-white tracking-wider">{c.num}</span>
                  </div>
                </a>
              ))}
              <a href="tel:+20244782489"
                className="sm:col-span-2 p-4 bg-white/5 rounded-xl border border-white/5 hover:border-[#F28C18]/40 flex items-center gap-3 transition-all">
                <i className="fas fa-headset text-[#F28C18] text-base" />
                <div>
                  <span className="text-[9px] block uppercase text-zinc-500 font-bold">{t.contact.landline}</span>
                  <span className="font-black text-white tracking-wider">+20 (2) 44782489</span>
                </div>
              </a>
            </div>
          </div>

          {/* Right form */}
          <div className="lg:col-span-7 bg-[#1A1A1C] border border-white/5 p-8 sm:p-10 rounded-2xl">
            {submitted ? (
              <div className="flex flex-col items-center justify-center text-center py-20 space-y-4">
                <div className="w-16 h-16 rounded-full bg-[#F28C18]/10 flex items-center justify-center">
                  <i className="fas fa-check text-[#F28C18] text-2xl" />
                </div>
                <p className="text-white font-black uppercase tracking-widest">{t.contact.success}</p>
                <p className="text-zinc-500 text-sm">{t.contact.successSub}</p>
              </div>
            ) : (
              <form onSubmit={handleSubmit} className="space-y-6">
                <div className="grid sm:grid-cols-2 gap-5">
                  {[
                    { type:"text",  key:"name",  ph:"name"  },
                    { type:"email", key:"email", ph:"email" },
                  ].map(f => (
                    <div key={f.key} className="space-y-2">
                      <label className="text-[10px] font-black text-zinc-400 uppercase tracking-widest block">{t.contact.fields[f.key]}</label>
                      <input type={f.type} required
                        className="w-full bg-[#111112] border border-white/10 rounded-lg p-3.5 text-xs text-white focus:outline-none focus:border-[#F28C18] transition-colors placeholder-zinc-700"
                        placeholder={t.contact.placeholders[f.ph]} />
                    </div>
                  ))}
                </div>
                <div className="grid sm:grid-cols-2 gap-5">
                  <div className="space-y-2">
                    <label className="text-[10px] font-black text-zinc-400 uppercase tracking-widest block">{t.contact.fields.phone}</label>
                    <input type="tel" required
                      className="w-full bg-[#111112] border border-white/10 rounded-lg p-3.5 text-xs text-white focus:outline-none focus:border-[#F28C18] transition-colors placeholder-zinc-700"
                      placeholder={t.contact.placeholders.phone} />
                  </div>
                  <div className="space-y-2">
                    <label className="text-[10px] font-black text-zinc-400 uppercase tracking-widest block">{t.contact.fields.scope}</label>
                    <select className="w-full bg-[#111112] border border-white/10 rounded-lg p-3.5 text-xs text-white focus:outline-none focus:border-[#F28C18] transition-colors cursor-pointer">
                      {t.contact.scopeOptions.map(o => <option key={o}>{o}</option>)}
                    </select>
                  </div>
                </div>
                <div className="space-y-2">
                  <label className="text-[10px] font-black text-zinc-400 uppercase tracking-widest block">{t.contact.fields.message}</label>
                  <textarea required rows={4} placeholder={t.contact.placeholders.message}
                    className="w-full bg-[#111112] border border-white/10 rounded-lg p-3.5 text-xs text-white focus:outline-none focus:border-[#F28C18] transition-colors resize-none placeholder-zinc-700" />
                </div>
                <button type="submit"
                  className="w-full py-4 bg-[#F28C18] text-black text-xs font-black tracking-widest uppercase rounded-lg hover:bg-white transition-all flex items-center justify-center gap-2">
                  <i className="fas fa-paper-plane" /> {t.contact.submit}
                </button>
              </form>
            )}
          </div>
        </div>
      </div>
    </section>
  );
}
